// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__1kC1F","cardHeader":"styles_cardHeader__33-Uz","buttons":"styles_buttons__1Xlh0"};